export default import.meta.ROLLDOWN_FILE_URL_rYfR0y55iGUMn8XdAn2pTg